module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk med tjenesteløfte_sentrert logo_neg(hvit).fe849c7b.svg";